import operatorApiFetch from './apiService';

export const shippingTypeService = {
  // 列表（與 admin service 保持一致）
  index: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString ? `shipping_types?${queryString}` : 'shipping_types';
      const response = await operatorApiFetch(url);
      if (!response.ok) throw new Error('Failed to fetch shipping types');
      const data = await response.json();
      return { success: true, data: data.data };
    } catch (error) {
      console.error(error);
      return { success: false, error: error.message };
    }
  },

  listAll: async () => {
    try {
      const response = await operatorApiFetch('shipping_types/list_all');
      if (!response.ok) throw new Error('Failed to fetch shipping types');
      const data = await response.json();
      return { success: true, data: data.data };
    } catch (error) {
      console.error(error);
      return { success: false, error: error.message };
    }
  },

  create: async (data) => {
    try {
      const response = await operatorApiFetch('shipping_types', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ shipping_type: data }),
      });
      const resData = await response.json();
      if (!response.ok) {
        return { success: false, message: resData.message, errors: resData.errors };
      }
      return { success: true, data: resData };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  update: async (id, data) => {
    try {
      const response = await operatorApiFetch(`shipping_types/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ shipping_type: data }),
      });
      const resData = await response.json();
      if (!response.ok) {
        return { success: false, message: resData.message, errors: resData.errors };
      }
      return { success: true };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  // 取得系統物流目錄（含啟用狀態）
  catalog: async () => {
    try {
      const response = await operatorApiFetch('shipping_types/catalog');
      if (!response.ok) throw new Error('Failed to fetch shipping type catalog');
      const data = await response.json();
      return { success: true, data: data.data };
    } catch (error) {
      console.error(error);
      return { success: false, error: error.message };
    }
  },

  // 啟用系統物流
  activate: async (code) => {
    try {
      const response = await operatorApiFetch('shipping_types/activate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to activate shipping type');
      }
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // 停用系統物流
  deactivate: async (code) => {
    try {
      const response = await operatorApiFetch('shipping_types/deactivate', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to deactivate shipping type');
      }
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
};
